import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["arrowStyle", "balloonzIndex", "contentStyle", "children", "onClose", "position", "noRole", "disableFocusTrap"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import React from "react";
import { ZINDEX } from "../../common/constants";
import Popup from "../Popup/Popup";
import extractTheme from "./extractTheme";
/**
 * Balloon provides a stylized container constrained to a context/triggering element.
 * It also provides a `chevron` that always points to the center (horizontally) of the
 * triggering element.
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const Balloon = /*#__PURE__*/React.forwardRef((_ref, balloonRef) => {
  let {
    arrowStyle,
    balloonzIndex,
    contentStyle,
    children,
    onClose,
    position,
    noRole,
    disableFocusTrap
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  const {
    cssBalloonRoot,
    cssBalloonArrow
  } = extractTheme({
    theme
  });

  const combinedContentStyle = _objectSpread(_objectSpread({}, cssBalloonRoot), contentStyle);

  const combinedArrowStyle = _objectSpread(_objectSpread({}, cssBalloonArrow), arrowStyle);

  return _jsx(Popup, _objectSpread(_objectSpread({
    repositionOnResize: true,
    closeOnEscape: true,
    closeOnDocumentClick: true,
    keepTooltipInside: true,
    ref: balloonRef,
    type: "balloon",
    on: ["click"],
    modal: false,
    noRole: noRole,
    position: position,
    onClose: event => onClose && onClose(event),
    zIndex: balloonzIndex,
    contentStyle: combinedContentStyle,
    arrowStyle: combinedArrowStyle,
    disableFocusTrap: disableFocusTrap
  }, otherProps), {}, {
    children: children
  }));
});
Balloon.propTypes = process.env.NODE_ENV !== "production" ? {
  arrowStyle: PropTypes.shape(),

  /** The zIndex of the balloon in relation to other elements on the page. */
  balloonzIndex: PropTypes.number,

  /** This is what will be displayed inside the component. */
  children: PropTypes.node,
  contentStyle: PropTypes.shape(),
  disableFocusTrap: PropTypes.bool,
  noRole: PropTypes.bool,

  /** Handler to be executed onClose of Balloon. */
  onClose: PropTypes.func,
  position: PropTypes.oneOfType([PropTypes.oneOf(["top left", "top center", "top right", "right top", "right center", "right bottom", "bottom left", "bottom center", "bottom right", "left top", "left center", "left bottom"]), PropTypes.arrayOf(PropTypes.string)])
} : {};
Balloon.defaultProps = {
  arrowStyle: {},
  balloonzIndex: ZINDEX.BALLOON_BUTTON,
  children: null,
  contentStyle: {},
  disableFocusTrap: false,
  onClose: null,
  position: ["top left", "top center", "bottom left", "bottom center", "left center", "right center"],
  noRole: false
};
Balloon.displayName = "Balloon";
export default Balloon;